import React from "react";
import styled from "styled-components";
import { border, color, layout } from "styled-system";
import { Flex } from "./Flex";
import { Icon } from "./Icon";
export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" }) `
  cursor: pointer;
  height: 16px;
  margin: 0;
  opacity: 0;
  position: absolute;
  z-index: 1;

  /* Override web-client styles */
  width: 16px !important;

  &:disabled {
    cursor: not-allowed;
  }
`;
export const StyledCheckbox = styled.span(border, color, layout, ({ theme: { borders, shadows, colors: { checkboxColors }, }, }) => ({
    // Disabled and readOnly states should look the same
    [`${HiddenCheckbox}:disabled + &,
      &.readOnly`]: {
        background: checkboxColors.checkboxDisabledBackground,
        borderColor: checkboxColors.checkboxDisabledBorder,
        color: checkboxColors.checkboxDisabledCheckmark,
    },
    [`${HiddenCheckbox}:checked:disabled + &`]: {
        background: checkboxColors.checkboxDisabledBackground,
        borderColor: checkboxColors.checkboxDisabledBorder,
    },
    [`${HiddenCheckbox}:focus + &`]: {
        borderColor: checkboxColors.checkboxFocusBorder,
        boxShadow: shadows.searchBox.contentShadow,
    },
    alignItems: "center",
    background: checkboxColors.checkboxBackground,
    border: borders[1],
    borderColor: checkboxColors.checkboxBorder,
    borderRadius: "3px",
    boxSizing: "content-box",
    color: checkboxColors.checkboxCheckmark,
    cursor: "pointer",
    display: "inline-flex",
    height: "14px",
    width: "14px",
}));
export const NewCheckIcon = ({ indeterminate, checked }) => {
    if (checked) {
        return React.createElement(Icon, { src: indeterminate ? "Subtract" : "Check" });
    }
    return null;
};
export const Checkbox = React.forwardRef(({ checked: defaultChecked, containerProps, "data-testid": dataTestid, "data-trackid": dataTrackid, descriptorId, disabled = false, indeterminate, name, onChange, onClick, onBlur, value, readOnly, }, ref) => {
    const checked = indeterminate ? true : defaultChecked;
    const handleClick = (event) => {
        if (!onClick || readOnly || disabled) {
            return;
        }
        onClick(event);
    };
    const handleChange = (event) => {
        if (!onChange || readOnly || disabled) {
            return;
        }
        onChange(event);
    };
    return (
    /* Needs a minWidth, otherwise the box can get squished */
    /* Added a top 2px so that the box sits a bit lower with the baseline and first line of text looks centered with box */
    React.createElement(Flex, { height: "16px", margin: "0", position: "relative", minWidth: "16px", width: "16px", sx: Object.assign({}, containerProps) },
        React.createElement(HiddenCheckbox, { readOnly: true, name: name, value: value, disabled: disabled, checked: checked, onBlur: onBlur, onChange: handleChange, onClick: handleClick, "data-testid": dataTestid, "data-trackid": dataTrackid, "aria-describedby": descriptorId, ref: ref }),
        React.createElement(StyledCheckbox, { className: readOnly ? "readOnly" : "" },
            React.createElement(NewCheckIcon, { checked: checked, indeterminate: indeterminate }))));
});
